<template>
  <div class="general-form-skeleton">
    <FormTitle title="General info" />
    <div class="general-form-skeleton__container">
      <div>
        <FormSubTitle title="Inner info" />
        <div class="d-flex flex-column">
          <div class="d-flex flex-column mb-2">
            <Skeleton class="mb-1" width="80px" />
            <Skeleton width="270px" height="40px" />
          </div>
          <div class="d-flex flex-column">
            <Skeleton class="mb-1" width="80px" />
            <Skeleton width="270px" height="55px" />
          </div>
        </div>
        <FormSubTitle title="General settings" class="mt-3" />
        <div class="d-flex flex-column" style="max-width: 500px;">
          <div class="tab-content-container mb-3">
            <a-tabs type="card">
              <a-tab-pane key="1">
                <template #tab>
                  <div>
                    <Skeleton width="80px" />
                  </div>
                </template>
                <div class="d-flex flex-column">
                  <Skeleton class="mb-1" width="80px" />
                  <Skeleton height="40px" />
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
          <a-row class="d-flex align-items-center mb-4">
            <div class="d-flex flex-column">
              <Skeleton class="mb-1" width="80px" />
              <Skeleton width="195px" height="40px" />
            </div>
            <span class="mx-3 align-self-end mb-2">—</span>
            <div class="d-flex flex-column">
              <Skeleton class="mb-1" width="80px" />
              <Skeleton width="195px" height="40px" />
            </div>
          </a-row>
          <div class="d-flex flex-column mb-2">
            <Skeleton class="mb-1" width="80px" />
            <Skeleton height="40px" />
          </div>
          <div class="d-flex flex-column">
            <Skeleton class="mb-1" width="80px" />
            <Skeleton height="40px" />
          </div>
        </div>
      </div>
      <div>
        <FormSubTitle title="Apps and languages" />
        <a-row style="width: 100%;" class="mb-2">
          <div class="d-flex flex-column">
            <Skeleton class="mb-1" width="120px" />
            <div class="d-flex">
              <Skeleton class="mr-1" width="80px" height="24px" />
              <Skeleton class="mr-1" width="80px" height="24px" />
            </div>
          </div>
        </a-row>
        <a-row>
          <div class="d-flex flex-column">
            <Skeleton class="mb-1" width="80px" />
            <div class="d-flex flex-column">
              <Skeleton width="270px" height="40px" class="mb-1" />
              <Skeleton width="270px" height="40px" />
            </div>
          </div>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import FormTitle from '@/components/custom/form/FormTitle.vue'
import FormSubTitle from '@/components/custom/form/FormSubTitle.vue'
import Skeleton from '@/components/custom/skeleton/Skeleton.vue'

export default {
  components: {
    FormTitle,
    FormSubTitle,
    Skeleton,
  },
}
</script>

<style lang="scss">
.general-form-skeleton {
  &__container {
    display: flex;
    flex-wrap: wrap;
    gap: 200px;
    @media (max-width: 768px) {
      gap: 20px;
    }
  }
  .tab-content-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 500px;
    overflow-y: scroll;
  }

  .ant-tabs-card > .ant-tabs-content {
    margin-top: -16px;
  }

  .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    padding: 16px 8px 8px;
    border-right: 1px solid #e4e9f0;
    border-bottom: 1px solid #e4e9f0;
    border-left: 1px solid #e4e9f0;
    border-radius: 0 0 4px 4px;
  }

  .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    display: flex;
    align-items: center;
    border-color: transparent;
    background: transparent;
    margin-right: 0 !important;
  }
}
</style>
